import React from 'react';
import { formatHourRange } from '../utils/scheduleUtils';
import './ScheduleRangeModal.css';

const ScheduleRangeModal = ({
  mode,
  dayLabel,
  dateLabel,
  startHour,
  endHour,
  saving,
  onClose,
  onConfirm,
}) => {
  const titles = {
    add: 'Добавить доступность',
    modify: 'Изменить доступность',
    delete: 'Удалить доступность',
  };
  const title = titles[mode] || titles.add;
  const timeLabel = formatHourRange(startHour, endHour);

  const hints = {
    add: 'Выберите, куда добавить этот интервал:',
    modify: 'Выберите, как применить изменение:',
    delete: 'Выберите, откуда удалить этот интервал:',
  };

  const permanentLabels = {
    add: 'В постоянное расписание',
    modify: 'Изменить постоянно',
    delete: 'Удалить постоянно',
  };

  const weekLabels = {
    add: 'Только на эту неделю',
    modify: 'Только эту неделю',
    delete: 'Удалить на эту неделю',
  };

  return (
    <div className="schedule-range-overlay" onClick={onClose}>
      <div className="schedule-range-modal" onClick={(e) => e.stopPropagation()}>
        <div className="schedule-range-header">
          <h3>{title}</h3>
          <button type="button" className="schedule-range-close" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>

        <div className="schedule-range-body">
          <p className="schedule-range-when">
            <strong>{dayLabel}</strong>
            {dateLabel && <span>, {dateLabel}</span>}
          </p>
          <p className="schedule-range-time">{timeLabel}</p>
          <p className="schedule-range-hint">{hints[mode] || hints.add}</p>
        </div>

        <div className="schedule-range-actions">
          <button
            type="button"
            className="schedule-range-btn schedule-range-btn--permanent"
            disabled={saving}
            onClick={() => onConfirm('permanent')}
          >
            {permanentLabels[mode] || permanentLabels.add}
          </button>
          <button
            type="button"
            className="schedule-range-btn schedule-range-btn--week"
            disabled={saving}
            onClick={() => onConfirm('week')}
          >
            {weekLabels[mode] || weekLabels.add}
          </button>
          <button
            type="button"
            className="schedule-range-btn schedule-range-btn--cancel"
            onClick={onClose}
            disabled={saving}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleRangeModal;
